import React from 'react';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { Stack } from '@cp/ds/src/components/stack';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { CareerIcon } from '@cp/entities/career';
import { Button } from '@cp/ds/src/components/button';
import { IModalProps } from '@cp/shared/modal';
import { ClientSelection } from 'src/entities/client';

const items = [
  {
    value: 3,
    label: 'Срочно',
  },
  {
    value: 2,
    label: 'На неделе',
  },
  {
    value: 1,
    label: 'В этом месяце',
  },
  {
    value: 0,
    label: 'Просто смотрю',
  },
];

export interface NeedHelpTimingProps extends IModalProps<number> {
  clientSelection: ClientSelection;
}
const NeedHelpTimingModal: React.FC<NeedHelpTimingProps> = ({ clientSelection, onSuccess, onCancel }) => {
  const isMobile = useIsMobile();

  return (
    <ModalLayout
      containerSx={{ maxHeight: { xs: 1, md: 480 } }}
      icon={isMobile ? undefined : <CareerIcon careerId={clientSelection.careerId} />}
      onClose={onCancel}
      title="Когда нужна услуга?"
    >
      <ModalContainer>
        <Stack gap={1}>
          {items.map(({ value, label }) => {
            return (
              <Button color="white" key={value} onClick={() => onSuccess(value)} variant="primary">
                {label}
              </Button>
            );
          })}
        </Stack>
      </ModalContainer>
    </ModalLayout>
  );
};

export default NeedHelpTimingModal;
